import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Std$Bolt0 from "bolt0/./std.bs.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Bolt0_fn$Bolt0 from "bolt0/./bolt0_fn.bs.js";
import * as Csv$SolvuuApi0 from "./csv.bs.js";
import * as Bolt0_res$Bolt0 from "bolt0/./bolt0_res.bs.js";
import * as Lang$SolvuuApi0 from "./lang.bs.js";
import * as Root$SolvuuApi0 from "./root.bs.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Bolt0_option$Bolt0 from "bolt0/./bolt0_option.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";
import * as Fmt_format_of_request_atd$SolvuuApi0 from "./fmt_format_of_request_atd.bs.js";
import * as Fmt_format_of_response_atd$SolvuuApi0 from "./fmt_format_of_response_atd.bs.js";

function spec_and_data(map) {
  var spec = Curry._1(Lang$SolvuuApi0.Record.Param.Arg_type.create, function (param) {
    if (typeof param === "number" || param[0] !== 847309489) {
      return (
        /* Invalid */
        144245463
      );
    } else {
      return (
        /* `Ok */
        [17724, param[1]]
      );
    }
  });

  var spec$1 = Curry._2(Lang$SolvuuApi0.Record.Param.flag,
  /* `Positional */
  [-300665356, 1], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, spec));

  var data = Curry._2(Lang$SolvuuApi0.Record.Param.flag,
  /* `Positional */
  [-300665356, 2], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.data));

  var make = function make(spec, data) {
    return (
      /* tuple */
      [spec, data]
    );
  };

  var param = Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._1(Lang$SolvuuApi0.Record.Param.$$return, make), spec$1), data);

  return Curry._2(Lang$SolvuuApi0.Record.Param.parse, map, param);
}

function of_term(term) {
  var var_to_fmt = function var_to_fmt(fmt, $$var, data) {
    var simple = Bolt0_list$Bolt0.map(function (param) {
      var fmt = param[1];
      return (
        /* tuple */
        [param[0], function (param) {
          return (
            /* `Ok */
            [17724,
            /* tuple */
            [fmt, data]]
          );
        }]
      );
    },
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.bool,
    /* Bool */
    737456202],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.$$float,
    /* Float */
    365180284],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.$$int,
    /* Int */
    3654863],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.string,
    /* String */
    -976970511],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.bam,
    /* Bam */
    3303854],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.bam_index,
    /* Bam_index */
    -50740607],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.fasta_index,
    /* Fasta_index */
    -1040940488],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.bed,
    /* Bed */
    3304737],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.bigbed,
    /* Bigbed */
    486566049],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.bigwig,
    /* Bigwig */
    487611253],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.gtf,
    /* Gtf */
    3556729],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.vcf,
    /* Vcf */
    4298873],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.vcf_index,
    /* Vcf_index */
    -953902196],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.newick,
    /* Newick */
    642196241],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.html,
    /* Html */
    804241803],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.png,
    /* Png */
    4002953],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.date,
    /* Date */
    758940238],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.ascii,
    /* Ascii */
    962246961],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.bash,
    /* Bash */
    736760884],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.cram,
    /* Cram */
    748691835],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.cram_index,
    /* Cram_index */
    -574959090],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.bytes,
    /* Bytes */
    -792364981],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.json,
    /* Json */
    826371656],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.qza,
    /* Qza */
    4055352],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.multiQC,
    /* MultiQC */
    -973518485],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.rdata,
    /* Rdata */
    -113318020],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.sam,
    /* Sam */
    4149247],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.identity,
    /* Bytes */
    -792364981],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu,
    /* Solvuu */
    -522825178],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_json,
    /* Solvuu_json */
    -972455391],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_runtime_json,
    /* Solvuu_runtime_json */
    107576104],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_eval_json,
    /* Solvuu_eval_json */
    -1015245230],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_type,
    /* Solvuu_type */
    -861261133],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_type_json,
    /* Solvuu_type_json */
    -293895564],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_fmt,
    /* Solvuu_fmt */
    -4561036],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_fmt_json,
    /* Solvuu_fmt_json */
    -619744749],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_bigdata,
    /* Solvuu_bigdata */
    -77614959],
    /* :: */
    [
    /* tuple */
    [Root$SolvuuApi0.solvuu_dataframe,
    /* Solvuu_dataframe */
    -56835286],
    /* [] */
    0]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]]);
    var tmp;

    if (data !== undefined) {
      var data$1 = data;
      var tmp$1;

      if (fmt !== undefined) {
        var fmt$1 = fmt;
        tmp$1 =
        /* :: */
        [
        /* tuple */
        [Root$SolvuuApi0.gunzip, function (param) {
          var fmt$2 = fmt$1;
          var data$2 = data$1;
          var match = loop(fmt$2, data$2);

          if (typeof match === "number") {
            return (
              /* `Ok */
              [17724,
              /* tuple */
              [
              /* `Gzip */
              [793449722, fmt$2], data$2]]
            );
          } else {
            var match$1 = match[1];
            return (
              /* `Ok */
              [17724,
              /* tuple */
              [
              /* `Gzip */
              [793449722, match$1[0]], match$1[1]]]
            );
          }
        }],
        /* [] */
        0];
      } else {
        tmp$1 =
        /* [] */
        0;
      }

      tmp = Pervasives.$at(
      /* :: */
      [
      /* tuple */
      [Root$SolvuuApi0.fasta, function (param) {
        var term = data$1;

        if (typeof term === "number" || term[0] !== 847309489) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          var record = term[1];

          if (record) {
            var match = record[0];
            var match$1 = match[0];

            if (typeof match$1 === "number" || match$1[0] !== -300665356 || match$1[1] !== 1) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              var match$2 = match[1];

              if (typeof match$2 === "number" || match$2[0] !== 847309489) {
                return (
                  /* Invalid */
                  144245463
                );
              } else {
                var match$3 = record[1];

                if (match$3) {
                  var match$4 = match$3[0];
                  var match$5 = match$4[0];

                  if (typeof match$5 === "number" || match$5[0] !== -300665356 || match$5[1] !== 2 || match$3[1]) {
                    return (
                      /* Invalid */
                      144245463
                    );
                  } else {
                    var string_or_null = Curry._1(Lang$SolvuuApi0.Record.Param.Arg_type.create, function (param) {
                      if (typeof param === "number") {
                        if (param !== 870828711) {
                          return (
                            /* Invalid */
                            144245463
                          );
                        } else {
                          return (
                            /* `Ok */
                            [17724, undefined]
                          );
                        }
                      } else if (param[0] !== -976970511) {
                        return (
                          /* Invalid */
                          144245463
                        );
                      } else {
                        return (
                          /* `Ok */
                          [17724, param[1]]
                        );
                      }
                    });

                    var int_or_null = Curry._1(Lang$SolvuuApi0.Record.Param.Arg_type.create, function (param) {
                      if (typeof param === "number") {
                        if (param !== 870828711) {
                          return (
                            /* Invalid */
                            144245463
                          );
                        } else {
                          return (
                            /* `Ok */
                            [17724, undefined]
                          );
                        }
                      } else if (param[0] !== 3654863) {
                        return (
                          /* Invalid */
                          144245463
                        );
                      } else {
                        return (
                          /* `Ok */
                          [17724, param[1]]
                        );
                      }
                    });

                    var allow_sharp_comments = Curry._2(Lang$SolvuuApi0.Record.Param.flag,
                    /* `Named */
                    [699531161, "allow_sharp_comments"], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.bool));

                    var allow_semicolon_comments = Curry._2(Lang$SolvuuApi0.Record.Param.flag,
                    /* `Named */
                    [699531161, "allow_semicolon_comments"], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.bool));

                    var allow_empty_lines = Curry._2(Lang$SolvuuApi0.Record.Param.flag,
                    /* `Named */
                    [699531161, "allow_empty_lines"], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.bool));

                    var allow_comments_only_at_top = Curry._2(Lang$SolvuuApi0.Record.Param.flag,
                    /* `Named */
                    [699531161, "allow_comments_only_at_top"], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.bool));

                    var max_line_length = Curry._2(Lang$SolvuuApi0.Record.Param.flag,
                    /* `Named */
                    [699531161, "max_line_length"], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, int_or_null));

                    var alphabet = Curry._2(Lang$SolvuuApi0.Record.Param.flag,
                    /* `Named */
                    [699531161, "alphabet"], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, string_or_null));

                    var make = function make(allow_sharp_comments, allow_semicolon_comments, allow_empty_lines, allow_comments_only_at_top, max_line_length, alphabet) {
                      return {
                        allow_sharp_comments: allow_sharp_comments,
                        allow_semicolon_comments: allow_semicolon_comments,
                        allow_empty_lines: allow_empty_lines,
                        allow_comments_only_at_top: allow_comments_only_at_top,
                        max_line_length: max_line_length,
                        alphabet: alphabet
                      };
                    };

                    var param$1 = Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._1(Lang$SolvuuApi0.Record.Param.$$return, make), allow_sharp_comments), allow_semicolon_comments), allow_empty_lines), allow_comments_only_at_top), max_line_length), alphabet);

                    var fmt_arg = Curry._2(Lang$SolvuuApi0.Record.Param.parse, match$2[1], param$1);

                    if (fmt_arg[0] >= 106380200) {
                      return (
                        /* Invalid */
                        144245463
                      );
                    } else {
                      return (
                        /* `Ok */
                        [17724,
                        /* tuple */
                        [
                        /* `Fasta */
                        [243398181, fmt_arg[1]], match$4[1]]]
                      );
                    }
                  }
                } else {
                  return (
                    /* Invalid */
                    144245463
                  );
                }
              }
            }
          } else {
            return (
              /* Invalid */
              144245463
            );
          }
        }
      }],
      /* :: */
      [
      /* tuple */
      [Root$SolvuuApi0.fastq, function (param) {
        var term = data$1;

        if (typeof term === "number" || term[0] !== 847309489) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          var record = term[1];

          if (record) {
            var match = record[0];
            var match$1 = match[0];

            if (typeof match$1 === "number" || match$1[0] !== -300665356 || match$1[1] !== 1) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              var match$2 = match[1];

              if (typeof match$2 === "number" || match$2[0] !== 847309489) {
                return (
                  /* Invalid */
                  144245463
                );
              } else {
                var match$3 = record[1];

                if (match$3) {
                  var match$4 = match$3[0];
                  var match$5 = match$4[0];

                  if (typeof match$5 === "number" || match$5[0] !== -300665356 || match$5[1] !== 2 || match$3[1]) {
                    return (
                      /* Invalid */
                      144245463
                    );
                  } else {
                    var label =
                    /* `Named */
                    [699531161, "encoding"];

                    var param$1 = Curry._2(Lang$SolvuuApi0.Record.Param.flag, label, Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.string));

                    var e = Curry._2(Lang$SolvuuApi0.Record.Param.parse, match$2[1], param$1);

                    var fmt_arg;

                    if (e[0] >= 106380200) {
                      fmt_arg = e;
                    } else {
                      switch (e[1]) {
                        case "phred33":
                          fmt_arg =
                          /* `Ok */
                          [17724,
                          /* Phred33 */
                          -91267303];
                          break;

                        case "phred64":
                          fmt_arg =
                          /* `Ok */
                          [17724,
                          /* Phred64 */
                          -91266633];
                          break;

                        case "solexa":
                          fmt_arg =
                          /* `Ok */
                          [17724,
                          /* Solexa */
                          -523669922];
                          break;

                        default:
                          fmt_arg =
                          /* `Error */
                          [106380200,
                          /* :: */
                          [
                          /* tuple */
                          [label,
                          /* Invalid */
                          144245463],
                          /* [] */
                          0]];
                      }
                    }

                    if (fmt_arg[0] >= 106380200) {
                      return (
                        /* Invalid */
                        144245463
                      );
                    } else {
                      return (
                        /* `Ok */
                        [17724,
                        /* tuple */
                        [
                        /* `Fastq */
                        [243398197, fmt_arg[1]], match$4[1]]]
                      );
                    }
                  }
                } else {
                  return (
                    /* Invalid */
                    144245463
                  );
                }
              }
            }
          } else {
            return (
              /* Invalid */
              144245463
            );
          }
        }
      }],
      /* :: */
      [
      /* tuple */
      [Root$SolvuuApi0.gff, function (param) {
        var term = data$1;
        return (
          /* `Ok */
          [17724,
          /* tuple */
          [
          /* `Gff */
          [3553607,
          /* Version2 */
          812255802], term]]
        );
      }],
      /* :: */
      [
      /* tuple */
      [Root$SolvuuApi0.biom, function (param) {
        var term = data$1;
        return (
          /* `Ok */
          [17724,
          /* tuple */
          [
          /* `Biom */
          [737157829,
          /* Json */
          826371656], term]]
        );
      }],
      /* :: */
      [
      /* tuple */
      [Root$SolvuuApi0.csv, function (param) {
        var data$2 = data$1;

        if (typeof data$2 === "number" || data$2[0] !== 847309489) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          var header = Curry._1(Lang$SolvuuApi0.Record.Param.Arg_type.create, function (param) {
            if (typeof param === "number") {
              return (
                /* Invalid */
                144245463
              );
            } else {
              var variant = param[0];

              if (variant !== -976970511) {
                if (variant !== 89433895) {
                  return (
                    /* Invalid */
                    144245463
                  );
                } else {
                  var match = param[1][1];

                  if (typeof match === "number" || match[0] !== -976970511) {
                    return (
                      /* Invalid */
                      144245463
                    );
                  } else {
                    return (
                      /* `Ok */
                      [17724, match[1]]
                    );
                  }
                }
              } else {
                return (
                  /* `Ok */
                  [17724, param[1]]
                );
              }
            }
          });

          var format = Curry._1(Lang$SolvuuApi0.Record.Param.Arg_type.create, function (term) {
            var match = loop(undefined, term);

            if (typeof match === "number") {
              return (
                /* Invalid */
                144245463
              );
            } else {
              return (
                /* `Ok */
                [17724, match[1][0]]
              );
            }
          });

          var action = Curry._1(Lang$SolvuuApi0.Record.Param.Arg_type.create, function (param) {
            if (typeof param === "number") {
              if (param !== 870828711) {
                return (
                  /* Invalid */
                  144245463
                );
              } else {
                return (
                  /* `Ok */
                  [17724,
                  /* Skip */
                  925778591]
                );
              }
            } else if (param[0] !== -976970511) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              switch (param[1]) {
                case "keep":
                  return (
                    /* `Ok */
                    [17724,
                    /* Keep */
                    836762789]
                  );

                case "skip":
                  return (
                    /* `Ok */
                    [17724,
                    /* Skip */
                    925778591]
                  );

                default:
                  return (
                    /* Invalid */
                    144245463
                  );
              }
            }
          });

          var header$1 = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.header, Curry._2(Lang$SolvuuApi0.Record.Param.Flag.optional_with_default, header, ""));

          var format$1 = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.format, Curry._2(Lang$SolvuuApi0.Record.Param.Flag.optional_with_default, format,
          /* Bytes */
          -792364981));

          var action$1 = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.action, Curry._2(Lang$SolvuuApi0.Record.Param.Flag.optional_with_default, action,
          /* Keep */
          836762789));

          var make = function make(header, format, action) {
            return {
              header: header,
              format: format,
              action: action
            };
          };

          var param$1 = Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._1(Lang$SolvuuApi0.Record.Param.$$return, make), header$1), format$1), action$1);

          var columns = Curry._1(Lang$SolvuuApi0.Record.Param.Arg_type.create, function (param$2) {
            if (typeof param$2 === "number" || param$2[0] !== 848054398) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              var l = Bolt0_list$Bolt0.map(function (param$3) {
                if (typeof param$3 === "number") {
                  if (param$3 !== 870828711) {
                    return (
                      /* `Error */
                      [106380200,
                      /* Invalid */
                      144245463]
                    );
                  } else {
                    return (
                      /* `Ok */
                      [17724, {
                        header: "",
                        format:
                        /* Bytes */
                        -792364981,
                        action:
                        /* Skip */
                        925778591
                      }]
                    );
                  }
                } else if (param$3[0] !== 847309489) {
                  return (
                    /* `Error */
                    [106380200,
                    /* Invalid */
                    144245463]
                  );
                } else {
                  var ok = Curry._2(Lang$SolvuuApi0.Record.Param.parse, param$3[1], param$1);

                  if (ok[0] >= 106380200) {
                    return (
                      /* `Error */
                      [106380200,
                      /* Invalid */
                      144245463]
                    );
                  } else {
                    return ok;
                  }
                }
              }, param$2[1]);
              var match = Bolt0_res$Bolt0.all(l);

              if (match[0] >= 106380200) {
                return match[1];
              } else {
                return (
                  /* `Ok */
                  [17724, match[1]]
                );
              }
            }
          });

          var columns$1 = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.columns, Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, columns));

          var separator = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.separator, Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.$$char));

          var quote = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.quote, Curry._1(Lang$SolvuuApi0.Record.Param.Flag.optional, Lang$SolvuuApi0.Record.Param.Arg_type.$$char));

          var has_header = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.has_header, Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.bool));

          var comment_char = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.comment_char, Curry._1(Lang$SolvuuApi0.Record.Param.Flag.optional, Lang$SolvuuApi0.Record.Param.Arg_type.$$char));

          var shift_header = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.shift_header, Curry._2(Lang$SolvuuApi0.Record.Param.Flag.optional_with_default, Lang$SolvuuApi0.Record.Param.Arg_type.bool, false));

          var data$3 = Curry._2(Lang$SolvuuApi0.Record.Param.flag, Csv$SolvuuApi0.Const.Label.data, Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, Lang$SolvuuApi0.Record.Param.Arg_type.data));

          var make$1 = function make$1(columns, separator, comment_char, shift_header, quote, has_header, data) {
            return (
              /* tuple */
              [{
                columns: columns,
                separator: separator,
                comment_char: comment_char,
                shift_header: shift_header,
                has_header: has_header,
                quote: quote
              }, data]
            );
          };

          var param$2 = Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._2(Lang$SolvuuApi0.Record.Param.Applicative_infix.$less$star$great, Curry._1(Lang$SolvuuApi0.Record.Param.$$return, make$1), columns$1), separator), comment_char), shift_header), quote), has_header), data$3);

          var fmt_arg = Curry._2(Lang$SolvuuApi0.Record.Param.parse, data$2[1], param$2);

          if (fmt_arg[0] >= 106380200) {
            return (
              /* Invalid */
              144245463
            );
          } else {
            var match = fmt_arg[1];
            return (
              /* `Ok */
              [17724,
              /* tuple */
              [
              /* `Csv */
              [3357606, match[0]], match[1]]]
            );
          }
        }
      }],
      /* :: */
      [
      /* tuple */
      [Root$SolvuuApi0.maybe, function (param) {
        var fmt$2 = fmt;
        var data$2 = data$1;

        if (typeof data$2 === "number" || data$2[0] !== 847309489) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          var match = spec_and_data(data$2[1]);

          if (match[0] >= 106380200) {
            return (
              /* Invalid */
              144245463
            );
          } else {
            var match$1 = match[1];
            var data$3 = match$1[1];

            var lambda_or_var = Curry._1(Lang$SolvuuApi0.Record.Param.Arg_type.create, function (x) {
              if (typeof x === "number") {
                return (
                  /* Invalid */
                  144245463
                );
              } else {
                var variant = x[0];

                if (variant !== 4298439 && variant !== 89433895) {
                  return (
                    /* Invalid */
                    144245463
                  );
                } else {
                  return (
                    /* `Ok */
                    [17724, x]
                  );
                }
              }
            });

            var param$1 = Curry._2(Lang$SolvuuApi0.Record.Param.flag1,
            /* `Named */
            [699531161, "parse"], Curry._1(Lang$SolvuuApi0.Record.Param.Flag.required, lambda_or_var));

            var match$2 = Curry._2(Lang$SolvuuApi0.Record.Param.parse, match$1[0], param$1);

            if (match$2[0] >= 106380200) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              var parse = match$2[1];

              if (parse[0] >= 89433895) {
                var e = loop(fmt$2, parse[1][1]);

                if (typeof e === "number") {
                  return e;
                } else {
                  var fmt$3 = e[1][0];
                  var match$3 = loop(
                  /* `Maybe */
                  [374637448, fmt$3], data$3);

                  if (typeof match$3 === "number") {
                    return (
                      /* `Ok */
                      [17724,
                      /* tuple */
                      [
                      /* `Maybe */
                      [374637448, fmt$3], data$3]]
                    );
                  } else {
                    var match$4 = match$3[1];
                    return (
                      /* `Ok */
                      [17724,
                      /* tuple */
                      [match$4[0], match$4[1]]]
                    );
                  }
                }
              } else {
                return var_to_fmt(undefined, parse[1], data$3);
              }
            }
          }
        }
      }],
      /* [] */
      0]]]]]], tmp$1);
    } else {
      tmp =
      /* [] */
      0;
    }

    var lst = Pervasives.$at(simple, tmp);
    var match = Bolt0_list$Bolt0.find_opt(lst, function (param) {
      if (Curry._2(Lang$SolvuuApi0.Var.equal, $$var, param[0])) {
        return Curry._1(param[1],
        /* () */
        0);
      }
    });

    if (match !== undefined) {
      return match;
    } else {
      return (
        /* Invalid */
        144245463
      );
    }
  };

  var loop = function loop(fmt, _term) {
    while (true) {
      var term = _term;

      if (typeof term === "number") {
        return (
          /* Invalid */
          144245463
        );
      } else {
        var variant = term[0];

        if (variant !== 3257473) {
          if (variant !== 4298439) {
            if (variant !== 89433895) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              _term = term[1][1];
              continue;
            }
          } else {
            return var_to_fmt(fmt, term[1], undefined);
          }
        } else {
          var match = term[1];
          var term$1 = match[0];

          if (typeof term$1 !== "number" && term$1[0] === 4298439) {
            var match$1 = var_to_fmt(fmt, term$1[1], match[1]);

            if (typeof match$1 === "number") {
              return (
                /* Invalid */
                144245463
              );
            } else {
              var match$2 = match$1[1];
              var data = match$2[1];

              if (data !== undefined) {
                var data$1 = data;
                var fmt$1 = match$2[0];
                var match$3 = loop(fmt$1, data$1);

                if (typeof match$3 === "number") {
                  return (
                    /* `Ok */
                    [17724,
                    /* tuple */
                    [fmt$1, data$1]]
                  );
                } else {
                  var match$4 = match$3[1];
                  return (
                    /* `Ok */
                    [17724,
                    /* tuple */
                    [match$4[0], match$4[1]]]
                  );
                }
              } else {
                return (
                  /* Invalid */
                  144245463
                );
              }
            }
          }

          var data$2 = match[1];
          var match$5 = loop(fmt, term$1);

          if (typeof match$5 === "number") {
            return (
              /* Invalid */
              144245463
            );
          } else {
            var fmt$2 = match$5[1][0];
            var match$6 = loop(fmt$2, data$2);

            if (typeof match$6 === "number") {
              return (
                /* `Ok */
                [17724,
                /* tuple */
                [fmt$2, data$2]]
              );
            } else {
              var match$7 = match$6[1];
              return (
                /* `Ok */
                [17724,
                /* tuple */
                [match$7[0], match$7[1]]]
              );
            }
          }
        }
      }
    }

    ;
  };

  var match = loop(undefined, term);

  if (typeof match === "number") {
    return (
      /* Invalid */
      144245463
    );
  } else {
    var match$1 = match[1];
    var term$1 = match$1[1];

    if (term$1 !== undefined) {
      return (
        /* `Ok */
        [17724,
        /* tuple */
        [match$1[0], term$1]]
      );
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["fmt.ml", 348, 16]];
    }
  }
}

function to_term(format, data) {
  var loop = function loop(format, data) {
    if (typeof format === "number") {
      var $$var = format >= 3304737 ? format >= 486566049 ? format >= 748691835 ? format !== 758940238 ? format >= 826371656 ? format >= 962246961 ? Root$SolvuuApi0.ascii : Root$SolvuuApi0.json : format >= 804241803 ? Root$SolvuuApi0.html : Root$SolvuuApi0.cram : Root$SolvuuApi0.date : format !== 487611253 ? format >= 736760884 ? format >= 737456202 ? Root$SolvuuApi0.bool : Root$SolvuuApi0.bash : format >= 642196241 ? Root$SolvuuApi0.newick : Root$SolvuuApi0.bigbed : Root$SolvuuApi0.bigwig : format >= 4055352 ? format !== 4149247 ? format >= 107576104 ? format >= 365180284 ? Root$SolvuuApi0.$$float : Root$SolvuuApi0.solvuu_runtime_json : format >= 4298873 ? Root$SolvuuApi0.vcf : Root$SolvuuApi0.qza : Root$SolvuuApi0.sam : format >= 3654863 ? format >= 4002953 ? Root$SolvuuApi0.png : Root$SolvuuApi0.$$int : format >= 3556729 ? Root$SolvuuApi0.gtf : Root$SolvuuApi0.bed : format >= -574959090 ? format >= -77614959 ? format !== -56835286 ? format >= -4561036 ? format >= 3303854 ? Root$SolvuuApi0.bam : Root$SolvuuApi0.solvuu_fmt : format >= -50740607 ? Root$SolvuuApi0.bam_index : Root$SolvuuApi0.solvuu_bigdata : Root$SolvuuApi0.solvuu_dataframe : format >= -293895564 ? format >= -113318020 ? Root$SolvuuApi0.rdata : Root$SolvuuApi0.solvuu_type_json : format >= -522825178 ? Root$SolvuuApi0.solvuu : Root$SolvuuApi0.cram_index : format >= -972455391 ? format !== -953902196 ? format >= -792364981 ? format >= -619744749 ? Root$SolvuuApi0.solvuu_fmt_json : Root$SolvuuApi0.bytes : format >= -861261133 ? Root$SolvuuApi0.solvuu_type : Root$SolvuuApi0.solvuu_json : Root$SolvuuApi0.vcf_index : format >= -976970511 ? format >= -973518485 ? Root$SolvuuApi0.multiQC : Root$SolvuuApi0.string : format >= -1015245230 ? Root$SolvuuApi0.solvuu_eval_json : Root$SolvuuApi0.fasta_index;
      return (
        /* `App */
        [3257473,
        /* tuple */
        [
        /* `Var */
        [4298439, $$var], data]]
      );
    } else {
      var variant = format[0];

      if (variant >= 243398197) {
        if (variant >= 737157829) {
          if (variant >= 793449722) {
            return (
              /* `App */
              [3257473,
              /* tuple */
              [
              /* `Lambda */
              [89433895,
              /* tuple */
              ["x", loop(format[1],
              /* `Var */
              [4298439, Curry._1(Lang$SolvuuApi0.Var.Exn.of_string, "x")])]],
              /* `App */
              [3257473,
              /* tuple */
              [
              /* `Var */
              [4298439, Root$SolvuuApi0.gunzip], data]]]]
            );
          } else {
            return (
              /* `App */
              [3257473,
              /* tuple */
              [
              /* `Var */
              [4298439, Root$SolvuuApi0.biom], data]]
            );
          }
        } else if (variant >= 374637448) {
          return (
            /* `App */
            [3257473,
            /* tuple */
            [
            /* `Var */
            [4298439, Root$SolvuuApi0.maybe],
            /* `Record */
            [847309489,
            /* :: */
            [
            /* tuple */
            [
            /* `Positional */
            [-300665356, 1],
            /* `Record */
            [847309489,
            /* :: */
            [
            /* tuple */
            [
            /* `Named */
            [699531161, "parse"],
            /* `Lambda */
            [89433895,
            /* tuple */
            ["data", loop(format[1],
            /* `Var */
            [4298439, Curry._1(Lang$SolvuuApi0.Var.Exn.of_string, "data")])]]],
            /* [] */
            0]]],
            /* :: */
            [
            /* tuple */
            [
            /* `Positional */
            [-300665356, 2], data],
            /* [] */
            0]]]]]
          );
        } else {
          var x = format[1];
          var data$1 = data;
          var spec = Lang$SolvuuApi0.Term.record(
          /* :: */
          [
          /* tuple */
          ["encoding", x !== -91267303 ? x >= -91266633 ?
          /* `String */
          [-976970511, "phred64"] :
          /* `String */
          [-976970511, "solexa"] :
          /* `String */
          [-976970511, "phred33"]],
          /* [] */
          0]);
          return (
            /* `App */
            [3257473,
            /* tuple */
            [
            /* `Var */
            [4298439, Root$SolvuuApi0.fastq], Lang$SolvuuApi0.Term.tuple(
            /* :: */
            [spec,
            /* :: */
            [data$1,
            /* [] */
            0]])]]
          );
        }
      } else if (variant !== 3553607) {
        if (variant >= 243398181) {
          var x$1 = format[1];
          var data$2 = data;
          var match = x$1.alphabet;
          var match$1 = x$1.max_line_length;
          var spec$1 = Lang$SolvuuApi0.Term.record(
          /* :: */
          [
          /* tuple */
          ["allow_comments_only_at_top",
          /* `Bool */
          [737456202, x$1.allow_comments_only_at_top]],
          /* :: */
          [
          /* tuple */
          ["allow_empty_lines",
          /* `Bool */
          [737456202, x$1.allow_empty_lines]],
          /* :: */
          [
          /* tuple */
          ["allow_semicolon_comments",
          /* `Bool */
          [737456202, x$1.allow_semicolon_comments]],
          /* :: */
          [
          /* tuple */
          ["allow_sharp_comments",
          /* `Bool */
          [737456202, x$1.allow_sharp_comments]],
          /* :: */
          [
          /* tuple */
          ["alphabet", match !== undefined ?
          /* `String */
          [-976970511, match] :
          /* Null */
          870828711],
          /* :: */
          [
          /* tuple */
          ["max_line_length", match$1 !== undefined ?
          /* `Int */
          [3654863, match$1] :
          /* Null */
          870828711],
          /* [] */
          0]]]]]]);
          return (
            /* `App */
            [3257473,
            /* tuple */
            [
            /* `Var */
            [4298439, Root$SolvuuApi0.fasta], Lang$SolvuuApi0.Term.tuple(
            /* :: */
            [spec$1,
            /* :: */
            [data$2,
            /* [] */
            0]])]]
          );
        } else {
          var param = format[1];
          var data$3 = data;
          var columns_001 = Bolt0_list$Bolt0.map(function (param) {
            var action = param.action >= 925778591 ? "skip" : "keep";
            var format_term_001 =
            /* tuple */
            ["x", loop(param.format,
            /* `Var */
            [4298439, Curry._1(Lang$SolvuuApi0.Var.Exn.of_string, "x")])];
            var format_term =
            /* `Lambda */
            [89433895, format_term_001];
            var match = Lang$SolvuuApi0.Record.of_alist(
            /* :: */
            [
            /* tuple */
            [Csv$SolvuuApi0.Const.Label.header, Lang$SolvuuApi0.Term.const_string(param.header)],
            /* :: */
            [
            /* tuple */
            [Csv$SolvuuApi0.Const.Label.format, format_term],
            /* :: */
            [
            /* tuple */
            [Csv$SolvuuApi0.Const.Label.action,
            /* `String */
            [-976970511, action]],
            /* [] */
            0]]]);

            if (match[0] >= 17724) {
              return (
                /* `Record */
                [847309489, match[1]]
              );
            } else {
              return Curry._2(Std$Bolt0.failwithf(
              /* Format */
              [
              /* String_literal */
              Block.__(11, ["BUG: Duplicate key ",
              /* String */
              Block.__(2, [
              /* No_padding */
              0,
              /* End_of_format */
              0])]), "BUG: Duplicate key %s"]), Lang$SolvuuApi0.Label.to_string(match[1]),
              /* () */
              0);
            }
          }, param.columns);
          var columns =
          /* `List */
          [848054398, columns_001];

          var l = function (param) {
            return Bolt0_list$Bolt0.filter_map(param, Bolt0_fn$Bolt0.id);
          }(
          /* :: */
          [
          /* tuple */
          [Csv$SolvuuApi0.Const.Label.columns, columns],
          /* :: */
          [
          /* tuple */
          [Csv$SolvuuApi0.Const.Label.separator,
          /* `Char */
          [748194550, param.separator]],
          /* :: */
          [Bolt0_option$Bolt0.map(param.comment_char, function (x) {
            return (
              /* tuple */
              [Csv$SolvuuApi0.Const.Label.comment_char,
              /* `Char */
              [748194550, x]]
            );
          }),
          /* :: */
          [
          /* tuple */
          [Csv$SolvuuApi0.Const.Label.shift_header,
          /* `Bool */
          [737456202, param.shift_header]],
          /* :: */
          [Bolt0_option$Bolt0.map(param.quote, function (x) {
            return (
              /* tuple */
              [Csv$SolvuuApi0.Const.Label.quote,
              /* `Char */
              [748194550, x]]
            );
          }),
          /* :: */
          [
          /* tuple */
          [Csv$SolvuuApi0.Const.Label.has_header,
          /* `Bool */
          [737456202, param.has_header]],
          /* :: */
          [
          /* tuple */
          [Csv$SolvuuApi0.Const.Label.data, data$3],
          /* [] */
          0]]]]]]]);

          var match$2 = Lang$SolvuuApi0.Record.of_alist(l);

          if (match$2[0] >= 17724) {
            return (
              /* `App */
              [3257473,
              /* tuple */
              [
              /* `Var */
              [4298439, Root$SolvuuApi0.csv],
              /* `Record */
              [847309489, match$2[1]]]]
            );
          } else {
            return Curry._2(Std$Bolt0.failwithf(
            /* Format */
            [
            /* String_literal */
            Block.__(11, ["BUG: Duplicate key ",
            /* String */
            Block.__(2, [
            /* No_padding */
            0,
            /* End_of_format */
            0])]), "BUG: Duplicate key %s"]), Lang$SolvuuApi0.Label.to_string(match$2[1]),
            /* () */
            0);
          }
        }
      } else {
        return (
          /* `App */
          [3257473,
          /* tuple */
          [
          /* `Var */
          [4298439, Root$SolvuuApi0.gff], data]]
        );
      }
    }
  };

  return loop(format, data);
}

function path(param) {
  return (
    /* :: */
    ["format",
    /* :: */
    ["format-of",
    /* [] */
    0]]
  );
}

function body(ri) {
  return (
    /* `Json */
    [826371656, Curry._1(Fmt_format_of_request_atd$SolvuuApi0.json_of_info, ri)]
  );
}

function info(path, body) {
  if (path && path[0] === "format") {
    var match = path[1];

    if (match && match[0] === "format-of" && !match[1]) {
      if (typeof body === "number") {
        return Pervasives.failwith("Format.Format_of.request_info : invalid empty body");
      } else {
        return Curry._1(Fmt_format_of_request_atd$SolvuuApi0.info_of_json, body[1]);
      }
    }
  }

  return Pervasives.failwith(Curry._1(Printf.sprintf(
  /* Format */
  [
  /* String_literal */
  Block.__(11, ["Format.Format_of.request_info : expect path 'format/format-of' but got '",
  /* String */
  Block.__(2, [
  /* No_padding */
  0,
  /* Char_literal */
  Block.__(12, [
  /* "'" */
  39,
  /* End_of_format */
  0])])]), "Format.Format_of.request_info : expect path 'format/format-of' but got '%s'"]), $$String.concat("/", path)));
}

var Parse = {
  to_term: to_term,
  of_term: of_term
};
var Format_of_Request = {
  path: path,
  body: body,
  info: info
};
var Format_of_Response = {
  ok_of_json: Fmt_format_of_response_atd$SolvuuApi0.ok_of_json,
  json_of_ok: Fmt_format_of_response_atd$SolvuuApi0.json_of_ok,
  bad_request_of_json: Fmt_format_of_response_atd$SolvuuApi0.bad_request_of_json,
  json_of_bad_request: Fmt_format_of_response_atd$SolvuuApi0.json_of_bad_request,
  not_found_of_json: Fmt_format_of_response_atd$SolvuuApi0.not_found_of_json,
  json_of_not_found: Fmt_format_of_response_atd$SolvuuApi0.json_of_not_found
};
var Format_of = {
  entity: "formats",
  service: "Formats.Format_of",
  $$Request: Format_of_Request,
  $$Response: Format_of_Response
};
export { Parse, Format_of };
/* Csv-SolvuuApi0 Not a pure module */